export const defaultTimezone = "Europe/Berlin";

export const maxVoucherGeneratonAmount = 1000;
